<template lang="pug">
.reservation-schedule-template-table-component
  //- テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    //- フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- セル：設定内容
    template(#cell(detail)="row")
      .d-flex.flex-column
        span(v-for="detail in convertDetails(row.item)") {{ detail }}
    //- セル：操作
    template(#cell(control)="row")
      .control-buttons
        button.btn.edit-btn.mr-2(@click="onEdit(row.item)" type="button") 修正
        button.btn.delete-btn(@click="onDelete(row.item)" type="button") 削除
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReservationScheduleTemplateGetModel } from "@/commons/services/ReservationScheduleTemplates";

/**
 * ### 部屋テーブルコンポーネント
 */
@Component({})
export default class ReservationScheduleTemplateTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ReservationScheduleTemplateTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ReservationScheduleTemplateTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<ReservationScheduleTemplateTableItem> {
    return this.value;
  }

  public convertDetails(item: ReservationScheduleTemplateTableItem): string[] {
    const details: string[] = [];
    for (const week of item.weeks) {
      const weekNames: string[] = [];
      if (week.sunday) {
        weekNames.push("日");
      }
      if (week.monday) {
        weekNames.push("月");
      }
      if (week.tuesday) {
        weekNames.push("火");
      }
      if (week.wednesday) {
        weekNames.push("水");
      }
      if (week.thursday) {
        weekNames.push("木");
      }
      if (week.friday) {
        weekNames.push("金");
      }
      if (week.saturday) {
        weekNames.push("土");
      }
      const start = `${week.startHour}：${week.startMin}`;
      const end = `${week.endHour}：${week.endMin}`;
      details.push(weekNames.join("・") + "、" + `${start}～${end}`);
    }
    return details;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(item: ReservationScheduleTemplateTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(item, filter);
  }

  public filterSearchWords(item: ReservationScheduleTemplateTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundName: boolean = true;

    for (const word of words) {
      if (item.name.indexOf(word) == -1) {
        foundName = false;
      }
    }

    return foundName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(item: ReservationScheduleTemplateTableItem): void {
    this.$emit("onEdit", item);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(item: ReservationScheduleTemplateTableItem): void {
    this.$emit("onDelete", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface ReservationScheduleTemplateTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ReservationScheduleTemplateTableItem extends ReservationScheduleTemplateGetModel {}

export interface FilterSetting {
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.room-table-component {
  .edit-btn,
  .delete-btn {
    width: 64px;
  }

  .edit-btn {
    margin-right: 12px;
  }
}
</style>
